import React from 'react';
import moment from 'moment';
import {ProspectPoolTotalScoreRankHistory} from 'api';
import {ScoreChangeDisplay} from './ScoreChangeDisplay';
import {UpDownTag} from './UpDownTag';

interface Props {
  history: ProspectPoolTotalScoreRankHistory;
}

export const ScoreHistoryItem = ({history}: Props) => {
  const prospectScoreDetails =
    history.prospectPoolTotalScoreRankProspectStandardItemHistories || [];
  const companyScoreDetails =
    history.prospectPoolTotalScoreRankAccountStandardItemHistories || [];

  const leadTags = prospectScoreDetails.map((detail) => ({
    direction: detail.direction,
    text: detail.fieldName,
  }));

  const companyTags = companyScoreDetails.map((detail) => ({
    direction: detail.direction,
    text: detail.fieldName,
  }));

  return (
    <div className="relative flex items-start gap-4 px-2 pb-4 [&:not(:first-child)]:pt-4 bg-background-light border-b border-border">
      <span className="absolute top-0 right-0 text-foreground-light text-sm">
        {moment(history.createdDate).format('M/D')}
      </span>
      <div className="flex-1 flex flex-col gap-2">
        <ScoreChangeDisplay history={history} />

        {companyTags.length > 0 && (
          <div className="flex flex-col">
            <h5 className="text-xs font-bold text-foreground-light">企業</h5>
            <div className="flex gap-2 flex-wrap">
              {companyTags.map((tag, index) => (
                <UpDownTag
                  key={index}
                  direction={tag.direction as 'up' | 'down'}
                  label={tag.text}
                />
              ))}
            </div>
          </div>
        )}

        {leadTags.length > 0 && (
          <div className="flex flex-col">
            <h5 className="text-xs font-bold text-foreground-light">リード</h5>
            <div className="flex gap-2 flex-wrap">
              {leadTags.map((tag, index) => (
                <UpDownTag
                  key={index}
                  direction={tag.direction as 'up' | 'down'}
                  label={tag.text}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
